import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["libraryButton", "uploadButton", "libraryPanel", "uploadPanel"]

  connect() {
    this.#syncButtons()
  }

  showLibrary() {
    this.#togglePanel(this.libraryPanelTarget, this.uploadPanelTarget)
  }

  showUpload() {
    this.#togglePanel(this.uploadPanelTarget, this.libraryPanelTarget)
  }

  focusLibrary() {
    if (!this.libraryPanelTarget.classList.contains("hidden")) this.#focusPanel(this.libraryPanelTarget)
  }

  #togglePanel(panel, otherPanel) {
    const opening = panel.classList.contains("hidden")
    otherPanel.classList.add("hidden")
    panel.classList.toggle("hidden", !opening)
    this.#syncButtons()

    if (opening) requestAnimationFrame(() => this.#focusPanel(panel))
  }

  #syncButtons() {
    this.libraryButtonTarget.setAttribute("aria-expanded", String(!this.libraryPanelTarget.classList.contains("hidden")))
    this.uploadButtonTarget.setAttribute("aria-expanded", String(!this.uploadPanelTarget.classList.contains("hidden")))
  }

  #focusPanel(panel) {
    const interactive = panel.querySelector("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])")
    const focusTarget = interactive || panel
    focusTarget.focus()
  }
}
